import { formatVersionFooter } from '../../config/buildInfo';
import { CommonText } from '../../Constant/CommonText';

const AppVersionFooter = () => (
  <span
    style={{
      display: 'block',
      fontSize: 12,
      color: 'grey',
    }}
  >
    {CommonText.APP_NAME_TEXT} {formatVersionFooter()}
  </span>
);

export default AppVersionFooter;
